/**
 * KeywordResultsContainer - Handles keyword results display with tabs
 * Extracted from AppKeywordResearchPage for better separation of concerns
 */

import React from 'react';
import { KeywordTabs } from '@/modules/app/components/keyword-research';

interface KeywordResultsContainerProps {
  currentQuery: string;
  currentLanguageName: string;
  currentCountryName: string;
  userId: string | null;
  workspaceId?: string;
  workspaceName?: string;
  strictWorkspaceFiltering?: boolean;
}

const KeywordResultsContainer: React.FC<KeywordResultsContainerProps> = ({
  currentQuery,
  currentLanguageName,
  currentCountryName,
  userId,
  workspaceId,
  workspaceName,
  strictWorkspaceFiltering = false
}) => {
  return (
    <div className="px-6 pb-6">
      <KeywordTabs
        currentQuery={currentQuery}
        currentLanguageName={currentLanguageName}
        currentCountryName={currentCountryName}
        userId={userId}
        workspaceId={workspaceId}
        workspaceName={workspaceName}
        strictWorkspaceFiltering={strictWorkspaceFiltering}
      />
    </div>
  );
};

export default KeywordResultsContainer;